import Link from 'next/link';
import { Logo } from './Logo.jsx';
import { Container } from './Container.jsx';
import { ColorThemeBoundary } from '../ColorThemeBoundary.jsx';

export function Footer() {
  return (
    <ColorThemeBoundary theme="dark">
      <footer className="footer" role="contentinfo">
        <Container>
          <div className="footer__disclaimer">
            <p className="footer__brand">
              <Link href="/">
                <a>
                  <Logo />
                </a>
              </Link>
            </p>
            <p className="footer__copy">
              <Link href="/">
                <a>Penger.no</a>
              </Link>{' '}
              er et samarbeid mellom <a href="https://www.vg.no/">VG</a>,{' '}
              <a href="https://e24.no/">E24</a> og{' '}
              <a href="https://www.dinepenger.no/">Dine Penger</a>, og er eid av
              Verdens Gang AS. Tjenesten drives av{' '}
              <a href="https://www.vglab.no">VG Lab</a>.
            </p>
            <p className="footer__copy">
              Har du ris, ros eller forslag til forbedringer av tjenesten?
              Kontakt oss gjerne på{' '}
              <a href="mailto:hei@vglab.no">hei@vglab.no</a>!
            </p>
          </div>
          <nav className="footer__nav">
            <ul className="footer__links">
              <li>
                <Link href="/">
                  <a>Penger.no</a>
                </Link>
              </li>
              <li>
                <Link href="/boliglan">
                  <a>Boliglån</a>
                </Link>
              </li>
              <li>
                <Link href="/forbrukslan">
                  <a>Forbrukslån</a>
                </Link>
              </li>
            </ul>
            <ul className="footer__links">
              <li>
                <Link href="/om-tjenesten">
                  <a>Om oss</a>
                </Link>
              </li>
              <li>
                <Link href="/kontakt">
                  <a>Kontakt</a>
                </Link>
              </li>
              <li>
                <Link href="/personvern">
                  <a>Personvern</a>
                </Link>
              </li>
            </ul>
            <ul className="footer__links">
              <li>
                <a href="https://www.facebook.com/Penger.no">Facebook</a>
              </li>
            </ul>
          </nav>
        </Container>
        <style jsx>{`
          .footer {
            margin-top: 108px;
            padding: 54px 0 108px 0;
            background-color: var(--bgBlueish);
          }

          .footer :global(a) {
            color: var(--bgBlueish__tintedText);
            text-decoration: none;
          }

          .footer :global(a:hover) {
            color: var(--bgBlueish__text);
          }

          .footer__brand {
            margin: 0 0 36px 0;
            width: 180px;
            min-width: 180px;
          }

          .footer__copy {
            font-weight: 500;
            line-height: 1.5;
            color: var(--bgBlueish__text);
          }

          .footer__links {
            margin: 0;
            padding: 0;
            list-style: none;
          }

          .footer__links li {
            margin-bottom: 18px;
            font-size: 16px;
            font-weight: 600;
          }

          @media screen and (min-width: 750px) {
            .footer {
              padding: 144px 0;
            }

            .footer :global(> *) {
              display: grid;
              grid-template-columns: 2fr 4fr;
              grid-column-gap: 144px;
            }

            .footer__nav {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
            }
          }
        `}</style>
      </footer>
    </ColorThemeBoundary>
  );
}
